// extracted by mini-css-extract-plugin
module.exports = {"toggleBtn":"Sidebar_toggleBtn__E915k","drawer":"Sidebar_drawer__2BZsl","listItemLink":"Sidebar_listItemLink__FGnyd"};